/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const PageWelcomerIcon = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="17"
      fill="none"
      style={style}
    >
      <g clipPath="url(#clip0)" fill={color}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.889 5.194H3.333v3.112h9.556V5.194zm-.586.556H3.827v2h8.476v-2z"
        />
        <path d="M15.684 12.116h-.35V3.48a.948.948 0 00-.947-.947h-.335a.316.316 0 000 .631h.335c.174 0 .316.142.316.316v8.598H1.413V3.48c0-.174.14-.316.315-.316h9.805a.316.316 0 000-.63H1.728a.948.948 0 00-.947.946v8.637H.316a.315.315 0 00-.316.316v1.59c0 .522.425.947.947.947h14.106a.948.948 0 00.947-.947v-1.59a.315.315 0 00-.316-.316zm-.315 1.906a.316.316 0 01-.316.315H.947a.316.316 0 01-.316-.315v-1.274H15.37v1.274z" />
        <path d="M2.246 4.23v6.824c0 .174.14.315.315.315h11.125a.315.315 0 00.315-.315V5.849L14 4.23a.315.315 0 00-.316-.315H2.561a.315.315 0 00-.315.316zm.63.316h10.492l.002 1.304v4.888H2.877V4.546zM6.968 13.912h2.304a.315.315 0 100-.632H6.968a.316.316 0 000 .632zM1.5 13.897l.005.002a.316.316 0 00.18-.605l-.005-.001a.316.316 0 10-.18.604zM2.286 13.897l.006.002a.316.316 0 00.181-.605l-.006-.001a.316.316 0 10-.18.604zM3.073 13.897l.006.002a.313.313 0 00.393-.212.316.316 0 00-.212-.393l-.006-.001a.316.316 0 00-.18.604zM12.913 13.897l.006.002a.316.316 0 00.181-.605l-.006-.001a.315.315 0 10-.18.604zM13.7 13.897l.006.002a.316.316 0 00.18-.605l-.005-.001a.315.315 0 10-.18.604zM14.487 13.897l.006.002a.317.317 0 00.393-.212.316.316 0 00-.212-.392l-.006-.002a.316.316 0 10-.181.604zM12.707 3.15l.005.001a.316.316 0 10.181-.605l-.006-.001a.316.316 0 00-.18.604z" />
        <rect x="3.556" y="8.75" width="6.667" height=".444" rx=".222" />
        <rect x="3.556" y="9.639" width="6.667" height=".444" rx=".222" />
        <rect x="10.667" y="8.75" width="2.222" height=".444" rx=".222" />
        <rect x="10.667" y="9.639" width="2.222" height=".444" rx=".222" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 .75h16v16H0v-16z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
};
